import { createHook, createStore, StoreActionApi } from "react-sweet-state"
import { EntityState, setEntityField, } from "components/state/entity"
import { EntityErrors } from "components/validation/validatableentity"
import { LoadingStateDefaults } from "components/state/loader"
import { NoEntityError } from "components/validation/validatableentity"

interface Phone {
    phone: string;
}

interface State extends EntityState<Phone> {
    showDialog: boolean;
}

const StateDefaults: State = {
    ...LoadingStateDefaults,
    entity: { phone: null },
    errors: { ...NoEntityError },

    showDialog: false,
}

const changeDialogState = (show: boolean) =>
    (store: StoreActionApi<State>) => {
        store.setState((draft) => {
            draft.showDialog = show;
        });
    }


const setErrors = (errors: EntityErrors) =>
    (store: StoreActionApi<State>) => {
        store.setState((draft) => {
            draft.errors = errors;
        });
    }

const store = createStore({
    initialState: StateDefaults,
    actions: {
        changeDialogState,
        setEntityField,
        setErrors,
    },
    name: "MemberPhone"
});

const useState = createHook(store);

export {
    StateDefaults as MemberPhoneStateDefaults,
    State as MemberPhoneState,
    useState as useMemberPhone,
}
